var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "vulnerabilityDetailsModal",
        size: "xl",
        "hide-header-close": "",
        title: _vm.$t("message.vulnerability_details"),
      },
      on: {
        show: function ($event) {
          return _vm.onShow()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isReadonly,
                      expression: "!isReadonly",
                    },
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.VULNERABILITY_MANAGEMENT,
                      expression: "PERMISSIONS.VULNERABILITY_MANAGEMENT",
                    },
                  ],
                  attrs: {
                    size: "md",
                    variant: "outline-danger",
                    disabled:
                      _vm.vulnerability.components &&
                      _vm.vulnerability.components.length > 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.deleteVulnerability()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.delete")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isReadonly,
                      expression: "!isReadonly",
                    },
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.VULNERABILITY_MANAGEMENT,
                      expression: "PERMISSIONS.VULNERABILITY_MANAGEMENT",
                    },
                  ],
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateVulnerability()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: { border: "0", padding: "0" },
        },
        [
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              attrs: { active: "" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-edit" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.general"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "vulnerability-id-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "false",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      disabled: "true",
                      label: _vm.$t("message.vulnerability_vuln_id"),
                      tooltip: this.$t("message.vulnerability_vuln_id_desc"),
                      "feedback-text": _vm.$t(
                        "message.required_vulnerability_vuln_id"
                      ),
                    },
                    model: {
                      value: _vm.vulnerability.vulnId,
                      callback: function ($$v) {
                        _vm.$set(_vm.vulnerability, "vulnId", $$v)
                      },
                      expression: "vulnerability.vulnId",
                    },
                  }),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "vulnerability-title-input",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "true",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      label: _vm.$t("message.vulnerability_title"),
                      tooltip: this.$t("message.vulnerability_title_desc"),
                      readonly: _vm.isReadonly,
                    },
                    model: {
                      value: _vm.vulnerability.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.vulnerability, "title", $$v)
                      },
                      expression: "vulnerability.title",
                    },
                  }),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-input-group-form-select", {
                            attrs: {
                              required: "true",
                              options: _vm.severities,
                              label: _vm.$t("message.severity"),
                              tooltip: _vm.$t("message.severity"),
                              disabled: _vm.isReadonly,
                            },
                            model: {
                              value: _vm.vulnerability.severity,
                              callback: function ($$v) {
                                _vm.$set(_vm.vulnerability, "severity", $$v)
                              },
                              expression: "vulnerability.severity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-input-group-form-input", {
                            attrs: {
                              "input-group-size": "mb-3",
                              type: "text",
                              lazy: "true",
                              required: "false",
                              feedback: "false",
                              autofocus: "false",
                              disabled: "true",
                              label: _vm.$t("severity.cvss_severity"),
                              tooltip: this.$t("message.severity"),
                            },
                            model: {
                              value: _vm.computedCvssSeverity,
                              callback: function ($$v) {
                                _vm.computedCvssSeverity = $$v
                              },
                              expression: "computedCvssSeverity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-input-group-form-input", {
                            attrs: {
                              "input-group-size": "mb-3",
                              type: "text",
                              lazy: "true",
                              required: "false",
                              feedback: "false",
                              autofocus: "false",
                              disabled: "true",
                              label: _vm.$t("severity.owasp_rr_severity"),
                              tooltip: this.$t("message.severity"),
                            },
                            model: {
                              value: _vm.computedOwaspRRSeverity,
                              callback: function ($$v) {
                                _vm.computedOwaspRRSeverity = $$v
                              },
                              expression: "computedOwaspRRSeverity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: this.$t("message.aliases") } },
                    [
                      _c(
                        "div",
                        { staticClass: "list-group" },
                        [
                          _vm._l(
                            _vm.resolveVulnAliases(_vm.vulnerability.aliases),
                            function (alias) {
                              return _c(
                                "span",
                                [
                                  _c("actionable-list-group-item", {
                                    attrs: {
                                      value: alias.vulnId,
                                      "delete-icon": false,
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _c("actionable-list-group-item", {
                            attrs: { "add-icon": !_vm.isReadonly },
                            on: {
                              actionClicked: function ($event) {
                                return _vm.$root.$emit(
                                  "bv::show::modal",
                                  "selectCweModal"
                                )
                              },
                            },
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                  _c(
                    "b-form-group",
                    { attrs: { label: this.$t("message.cwe") } },
                    [
                      _c(
                        "div",
                        { staticClass: "list-group" },
                        [
                          _vm._l(_vm.selectableCwes, function (cwe) {
                            return _c(
                              "span",
                              [
                                _c("actionable-list-group-item", {
                                  attrs: {
                                    value: "CWE-" + cwe.cweId,
                                    "delete-icon": !_vm.isReadonly,
                                  },
                                  on: {
                                    actionClicked: function ($event) {
                                      return _vm.removeCwe(cwe)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _c("actionable-list-group-item", {
                            attrs: { "add-icon": !_vm.isReadonly },
                            on: {
                              actionClicked: function ($event) {
                                return _vm.$root.$emit(
                                  "bv::show::modal",
                                  "selectCweModal"
                                )
                              },
                            },
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                  _c("b-input-group-form-input", {
                    attrs: {
                      id: "vulnerability-uuid",
                      "input-group-size": "mb-3",
                      type: "text",
                      lazy: "false",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      disabled: "true",
                      label: _vm.$t("message.object_identifier"),
                      tooltip: this.$t("message.object_identifier_desc"),
                      readonly: true,
                    },
                    model: {
                      value: _vm.vulnerability.uuid,
                      callback: function ($$v) {
                        _vm.$set(_vm.vulnerability, "uuid", $$v)
                      },
                      expression: "vulnerability.uuid",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-newspaper-o" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.extended"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "vulnerability-description-form-group",
                        label: this.$t("message.description"),
                        "label-for": "vulnerability-description-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "vulnerability-description-description",
                          rows: "5",
                          readonly: _vm.isReadonly,
                        },
                        model: {
                          value: _vm.vulnerability.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.vulnerability, "description", $$v)
                          },
                          expression: "vulnerability.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "vulnerability-detail-form-group",
                        label: this.$t("message.details"),
                        "label-for": "vulnerability-detail-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "vulnerability-detail-description",
                          rows: "5",
                          readonly: _vm.isReadonly,
                        },
                        model: {
                          value: _vm.vulnerability.detail,
                          callback: function ($$v) {
                            _vm.$set(_vm.vulnerability, "detail", $$v)
                          },
                          expression: "vulnerability.detail",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "vulnerability-recommendation-form-group",
                        label: this.$t("message.recommendation"),
                        "label-for": "vulnerability-recommendation-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "vulnerability-recommendation-description",
                          rows: "5",
                          readonly: _vm.isReadonly,
                        },
                        model: {
                          value: _vm.vulnerability.recommendation,
                          callback: function ($$v) {
                            _vm.$set(_vm.vulnerability, "recommendation", $$v)
                          },
                          expression: "vulnerability.recommendation",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "vulnerability-references-form-group",
                        label: this.$t("message.references"),
                        "label-for": "vulnerability-references-input",
                      },
                    },
                    [
                      _c("b-form-textarea", {
                        attrs: {
                          id: "vulnerability-references-description",
                          rows: "5",
                          readonly: _vm.isReadonly,
                        },
                        model: {
                          value: _vm.vulnerability.references,
                          callback: function ($$v) {
                            _vm.$set(_vm.vulnerability, "references", $$v)
                          },
                          expression: "vulnerability.references",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-calculator" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.cvss_v2"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.severityColor(
                                  _vm.cvssV2Score.baseScore
                                ),
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent: _vm.cvssV2Score.baseScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.cvssV2Score.baseScore.toFixed(1))
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(_vm.$t("message.cvss_base_score_short"))
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.primaryColor,
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent: _vm.cvssV2Score.impactSubScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.cvssV2Score.impactSubScore.toFixed(1)
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(_vm._s(_vm.$t("message.cvss_impact"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.primaryColor,
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent:
                                  _vm.cvssV2Score.exploitabilitySubScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.cvssV2Score.exploitabilitySubScore.toFixed(
                                    1
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(_vm.$t("message.cvss_exploitability"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticStyle: { "margin-top": "2rem" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_attack_vector"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv2AttackVector }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv2Options.av,
                                        "aria-describedby": cvssv2AttackVector,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV2Vector },
                                      model: {
                                        value: _vm.cvssv2Vector.av,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv2Vector, "av", $$v)
                                        },
                                        expression: "cvssv2Vector.av",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_access_complexity"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv2AccessComplexity }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv2Options.ac,
                                        "aria-describedby":
                                          cvssv2AccessComplexity,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV2Vector },
                                      model: {
                                        value: _vm.cvssv2Vector.ac,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv2Vector, "ac", $$v)
                                        },
                                        expression: "cvssv2Vector.ac",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_authentication"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv2Authentication }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv2Options.au,
                                        "aria-describedby":
                                          cvssv2Authentication,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV2Vector },
                                      model: {
                                        value: _vm.cvssv2Vector.au,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv2Vector, "au", $$v)
                                        },
                                        expression: "cvssv2Vector.au",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.cvss_confidentiality_impact"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv2ConfidentialityImpact }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv2Options.c,
                                        "aria-describedby":
                                          cvssv2ConfidentialityImpact,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV2Vector },
                                      model: {
                                        value: _vm.cvssv2Vector.c,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv2Vector, "c", $$v)
                                        },
                                        expression: "cvssv2Vector.c",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_integrity_impact"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv2IntegrityImpact }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv2Options.i,
                                        "aria-describedby":
                                          cvssv2IntegrityImpact,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV2Vector },
                                      model: {
                                        value: _vm.cvssv2Vector.i,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv2Vector, "i", $$v)
                                        },
                                        expression: "cvssv2Vector.i",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_availability_impact"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv2AvailabilityImpact }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv2Options.a,
                                        "aria-describedby":
                                          cvssv2AvailabilityImpact,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV2Vector },
                                      model: {
                                        value: _vm.cvssv2Vector.a,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv2Vector, "a", $$v)
                                        },
                                        expression: "cvssv2Vector.a",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-calculator" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.cvss_v3"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.severityColor(
                                  _vm.cvssV3Score.baseScore
                                ),
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent: _vm.cvssV3Score.baseScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.cvssV3Score.baseScore.toFixed(1))
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(_vm.$t("message.cvss_base_score_short"))
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.primaryColor,
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent: _vm.cvssV3Score.impactSubScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.cvssV3Score.impactSubScore.toFixed(1)
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(_vm._s(_vm.$t("message.cvss_impact"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.primaryColor,
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent:
                                  _vm.cvssV3Score.exploitabilitySubScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.cvssV3Score.exploitabilitySubScore.toFixed(
                                    1
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(_vm.$t("message.cvss_exploitability"))
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticStyle: { "margin-top": "2rem" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_attack_vector"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3AttackVector }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-4-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.av,
                                        "aria-describedby": cvssv3AttackVector,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.av,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "av", $$v)
                                        },
                                        expression: "cvssv3Vector.av",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_attack_complexity"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3AttackComplexity }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.ac,
                                        "aria-describedby":
                                          cvssv3AttackComplexity,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.ac,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "ac", $$v)
                                        },
                                        expression: "cvssv3Vector.ac",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_privileges_required"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3PrivilegesRequired }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.pr,
                                        "aria-describedby":
                                          cvssv3PrivilegesRequired,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.pr,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "pr", $$v)
                                        },
                                        expression: "cvssv3Vector.pr",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_user_interaction"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3UserInteraction }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.ui,
                                        "aria-describedby":
                                          cvssv3UserInteraction,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.ui,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "ui", $$v)
                                        },
                                        expression: "cvssv3Vector.ui",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("b-form-group", {
                            attrs: { label: _vm.$t("message.cvss_scope") },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3Scope }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.s,
                                        "aria-describedby": cvssv3Scope,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.s,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "s", $$v)
                                        },
                                        expression: "cvssv3Vector.s",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.cvss_confidentiality_impact"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3ConfidentialityImpact }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.c,
                                        "aria-describedby":
                                          cvssv3ConfidentialityImpact,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.c,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "c", $$v)
                                        },
                                        expression: "cvssv3Vector.c",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_integrity_impact"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3IntegrityImpact }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.i,
                                        "aria-describedby":
                                          cvssv3IntegrityImpact,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.i,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "i", $$v)
                                        },
                                        expression: "cvssv3Vector.i",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.cvss_availability_impact"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ cvssv3AvailabilityImpact }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-3-btn",
                                      attrs: {
                                        options: _vm.cvssv3Options.a,
                                        "aria-describedby":
                                          cvssv3AvailabilityImpact,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateCvssV3Vector },
                                      model: {
                                        value: _vm.cvssv3Vector.a,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.cvssv3Vector, "a", $$v)
                                        },
                                        expression: "cvssv3Vector.a",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-calculator" }),
                      _vm._v("\n        " + _vm._s(_vm.$t("message.owasp_rr"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.owaspRRSeverityColor(
                                  _vm.owaspRRScore.likelihoodScore
                                ),
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent: _vm.owaspRRScore.likelihoodScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.owaspRRScore.likelihoodScore.toFixed(1)
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.owasp_rr_likelihood_score_short"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.owaspRRSeverityColor(
                                  _vm.owaspRRScore.technicalImpactScore
                                ),
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent:
                                  _vm.owaspRRScore.technicalImpactScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.owaspRRScore.technicalImpactScore.toFixed(
                                    1
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.owasp_rr_technical_impact_score_short"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { sm: "4" } },
                        [
                          _c(
                            "vue-easy-pie-chart",
                            {
                              attrs: {
                                "bar-color": _vm.owaspRRSeverityColor(
                                  _vm.owaspRRScore.businessImpactScore
                                ),
                                "track-color": _vm.recessedColor,
                                "scale-color": _vm.primaryColor,
                                "line-cap": "butt",
                                "line-width": 5,
                                "scale-length": 5,
                                percent:
                                  _vm.owaspRRScore.businessImpactScore * 10,
                                size: 90,
                                animate: true,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.owaspRRScore.businessImpactScore.toFixed(
                                    1
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.owasp_rr_business_impact_score_short"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticStyle: { "margin-top": "2rem" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.owasp_rr_threat_agent_factor")
                              )
                            ),
                          ]),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_skill_level"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRSkillLevel }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-4-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.sl,
                                        "aria-describedby": owaspRRSkillLevel,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.sl,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "sl", $$v)
                                        },
                                        expression: "owaspRRVector.sl",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_motivation"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRMotivation }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-4-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.m,
                                        "aria-describedby": owaspRRMotivation,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.m,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "m", $$v)
                                        },
                                        expression: "owaspRRVector.m",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_opportunity"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRROpportunity }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-4-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.o,
                                        "aria-describedby": owaspRROpportunity,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.o,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "o", $$v)
                                        },
                                        expression: "owaspRRVector.o",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_threat_size"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRThreatSize }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-4-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.s,
                                        "aria-describedby": owaspRRThreatSize,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.s,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "s", $$v)
                                        },
                                        expression: "owaspRRVector.s",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.owasp_rr_vulnerability_factor")
                              )
                            ),
                          ]),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_ease_of_discovery"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRREaseOfDiscovery }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.ed,
                                        "aria-describedby":
                                          owaspRREaseOfDiscovery,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.ed,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "ed", $$v)
                                        },
                                        expression: "owaspRRVector.ed",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_ease_of_exploit"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRREaseOfExploit }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.ee,
                                        "aria-describedby":
                                          owaspRREaseOfExploit,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.ee,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "ee", $$v)
                                        },
                                        expression: "owaspRRVector.ee",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_awareness"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRAwareness }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.a,
                                        "aria-describedby": owaspRRAwareness,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.a,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "a", $$v)
                                        },
                                        expression: "owaspRRVector.a",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_intrusion_detection"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRIntrusionDetection }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.id,
                                        "aria-describedby":
                                          owaspRRIntrusionDetection,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.id,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "id", $$v)
                                        },
                                        expression: "owaspRRVector.id",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.owasp_rr_technical_impact_factor"
                                )
                              )
                            ),
                          ]),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_loss_of_confidentiality"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({
                                  owaspRRLossOfConfidentiality,
                                }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.lc,
                                        "aria-describedby":
                                          owaspRRLossOfConfidentiality,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.lc,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "lc", $$v)
                                        },
                                        expression: "owaspRRVector.lc",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_loss_of_integrity"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRLossOfIntegrity }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.li,
                                        "aria-describedby":
                                          owaspRRLossOfIntegrity,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.li,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "li", $$v)
                                        },
                                        expression: "owaspRRVector.li",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_loss_of_availability"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRLossOfAvailibility }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.lav,
                                        "aria-describedby":
                                          owaspRRLossOfAvailibility,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.lav,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.owaspRRVector,
                                            "lav",
                                            $$v
                                          )
                                        },
                                        expression: "owaspRRVector.lav",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_loss_of_accountability"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRLossOfAccountability }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.lac,
                                        "aria-describedby":
                                          owaspRRLossOfAccountability,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.lac,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.owaspRRVector,
                                            "lac",
                                            $$v
                                          )
                                        },
                                        expression: "owaspRRVector.lac",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { sm: "6" } },
                        [
                          _c("h6", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "message.owasp_rr_business_impact_factor"
                                )
                              )
                            ),
                          ]),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_financial_damage"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRFinancialDamage }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.fd,
                                        "aria-describedby":
                                          owaspRRFinancialDamage,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.fd,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "fd", $$v)
                                        },
                                        expression: "owaspRRVector.fd",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_reputation_damage"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRReputationDamage }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.rd,
                                        "aria-describedby":
                                          owaspRRReputationDamage,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.rd,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "rd", $$v)
                                        },
                                        expression: "owaspRRVector.rd",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t("message.owasp_rr_non_compliance"),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRNonCompliance }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.nc,
                                        "aria-describedby":
                                          owaspRRNonCompliance,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.nc,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "nc", $$v)
                                        },
                                        expression: "owaspRRVector.nc",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-form-group", {
                            attrs: {
                              label: _vm.$t(
                                "message.owasp_rr_privacy_violation"
                              ),
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ owaspRRPrivacyViolation }) {
                                  return [
                                    _c("b-form-radio-group", {
                                      staticClass: "cvss-calc cvss-calc-2-btn",
                                      attrs: {
                                        options: _vm.owaspRROptions.pv,
                                        "aria-describedby":
                                          owaspRRPrivacyViolation,
                                        name: "radios-btn-default",
                                        "button-variant": "outline-primary",
                                        buttons: "",
                                        disabled: _vm.isReadonly,
                                      },
                                      on: { change: _vm.generateOwaspRRVector },
                                      model: {
                                        value: _vm.owaspRRVector.pv,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.owaspRRVector, "pv", $$v)
                                        },
                                        expression: "owaspRRVector.pv",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-cubes" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.affected_components"))
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("bootstrap-table", {
                    ref: "table",
                    attrs: {
                      columns: _vm.columns,
                      data: this.affectedVersionAttributions,
                      options: _vm.options,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              staticClass: "body-bg-color",
              staticStyle: { border: "0", padding: "0" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-calendar" }),
                      _vm._v(" " + _vm._s(_vm.$t("message.dates"))),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "b-card",
                [
                  _c("b-input-group-form-datepicker", {
                    attrs: {
                      id: "vulnerability-created-input",
                      "input-group-size": "mb-3",
                      lazy: "true",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      placeholder: "YYYY-MM-DD",
                      label: _vm.$t("message.created"),
                      tooltip: this.$t("message.vulnerability_created_desc"),
                    },
                    model: {
                      value: _vm.vulnerability.created,
                      callback: function ($$v) {
                        _vm.$set(_vm.vulnerability, "created", $$v)
                      },
                      expression: "vulnerability.created",
                    },
                  }),
                  _c("b-input-group-form-datepicker", {
                    attrs: {
                      id: "vulnerability-published_input",
                      "input-group-size": "mb-3",
                      lazy: "true",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      placeholder: "YYYY-MM-DD",
                      label: _vm.$t("message.published"),
                      tooltip: this.$t("message.vulnerability_published_desc"),
                      disabled: _vm.isReadonly,
                    },
                    model: {
                      value: _vm.vulnerability.published,
                      callback: function ($$v) {
                        _vm.$set(_vm.vulnerability, "published", $$v)
                      },
                      expression: "vulnerability.published",
                    },
                  }),
                  _c("b-input-group-form-datepicker", {
                    attrs: {
                      id: "vulnerability-updated-input",
                      "input-group-size": "mb-3",
                      lazy: "true",
                      required: "false",
                      feedback: "false",
                      autofocus: "false",
                      placeholder: "YYYY-MM-DD",
                      label: _vm.$t("message.updated"),
                      tooltip: this.$t("message.vulnerability_updated_desc"),
                      readonly: _vm.isReadonly,
                    },
                    model: {
                      value: _vm.vulnerability.updated,
                      callback: function ($$v) {
                        _vm.$set(_vm.vulnerability, "updated", $$v)
                      },
                      expression: "vulnerability.updated",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("select-cwe-modal", { on: { selection: _vm.updateCweSelection } }),
      _c("add-affected-component-modal", {
        on: { affectedComponentAdded: _vm.addAffectedComponent },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }